import Tag from '@preqin/ui-components/cjs/core/Tag';

import { ContactUsButton } from './ContactUsButton';

import styles from './UpsellText.module.scss';

export const TransactionIntelligenceText = () => {
  return (
    <div className={styles.container}>
      <div className={styles.titleWrapper}>
        <div className={styles.divider} />
        <h6>TRANSACTION INTELLIGENCE</h6>
        <div className={styles.tag}>
          <Tag label="Subscription required" type="info" />
        </div>
      </div>
      <h3 className={styles.header}>Discover new asset-level and deal-level insights</h3>
      <p className={styles.text}>
        Our new solution, Transaction Intelligence, gives you data on 7,000+ funds with $6 trillion committed capital,
        and 48,000+ deals worth a total of $4 trillion of capital invested in private markets.
      </p>
      <h3 className={styles.header}>How it works</h3>
      <p className={styles.text}>
        Colmore, a Preqin company, gathers fund performance, portfolio company, and LPA data directly from GPs. We then
        aggregate and anonymize this data to create the most up-to-date, reliable, and complete repository of
        transaction intelligence for our clients.
      </p>
      <h3 className={styles.header}>How to use it</h3>
      <p className={styles.text}>
        Explore aggregated deal performance and valuation multiples by choosing your preferred industry, geography, deal
        size, strategy, timing, and asset class criteria. Save multiple sets of criteria for future reference and export
        presentation-ready charts and tables.
      </p>
      <div className={styles.ctaWrapper}>
        <ContactUsButton label="Contact us to get access" link="https://pro.preqin.com/datasupport" />
      </div>
    </div>
  );
};
